import { useTranslation } from "react-i18next";
import { comparisonData } from "@/mocks/categories";

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section id="comparison" className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-3xl md:text-4xl mb-4">&#128202;</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            {t("comparison.title")}
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200/70">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-background-200/50">
                  <th className="py-4 px-5 md:px-6 text-sm font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                  <th className="py-4 px-5 md:px-6 text-sm font-semibold text-primary-700 whitespace-nowrap">
                    <span className="flex items-center gap-2">
                      <i className="ri-database-2-line text-base"></i>
                      {t("comparison.oopbuy")}
                    </span>
                  </th>
                  <th className="py-4 px-5 md:px-6 text-sm font-semibold text-foreground-500 whitespace-nowrap">
                    {t("comparison.manual")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr key={row.feature} className={`border-t border-background-200/50 ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}>
                    <td className="py-3.5 px-5 md:px-6 text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {row.feature}
                    </td>
                    <td className="py-3.5 px-5 md:px-6 text-sm text-foreground-700">
                      <span className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
                        {row.oopbuy}
                      </span>
                    </td>
                    <td className="py-3.5 px-5 md:px-6 text-sm text-foreground-500">
                      {row.manual}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}